<template>
    <div class="loading-animation">
        <i class="loading-animation__icon fas fa-cog fa-spin" />
        <span v-if="hasSlot" class="loading-animation__text"><slot /></span>
        <span v-else class="loading-animation__text">Loading&hellip;</span>
    </div>
</template>
<script>

export default {
    computed: {
        hasSlot() {
            return !!this.$slots.default
        },
    },
}

</script>
<style lang="scss">

.loading-animation {
    text-align: center;

    @include element('icon') {
        font-size: 5rem;
        max-width: 5rem;
        display: block;
        margin: 0 auto;
    }

    @include element('text') {
        display: block;
        margin-top: 1rem;
        font-size: 1.6rem;
        line-height: 1.8rem;
    }
}

</style>
